<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="12.5" y="8.5" width="23" height="31" stroke="#18181B" />
    <path
      d="M28.9434 25.2305L26.7373 29.4727L27.4883 29.2227L28.6924 28.8213L28.085 29.9365C27.2333 31.4996 26.2094 32.9626 25.0322 34.2979L25.0195 34.3115L25.0068 34.3242C24.2307 35.0833 23.1862 35.506 22.1006 35.5C21.0149 35.494 19.9757 35.0597 19.208 34.292C18.4403 33.5243 18.006 32.4851 18 31.3994C17.994 30.3138 18.4167 29.2693 19.1758 28.4932L19.1885 28.4805L19.2021 28.4678C20.538 27.2916 22.0011 26.2676 23.5635 25.415L24.6797 24.8066L24.2773 26.0117L24.0264 26.7617L28.2695 24.5566L29.6738 23.8262L28.9434 25.2305ZM21.8398 30.124C21.5865 30.1745 21.3535 30.2988 21.1709 30.4814C20.926 30.7264 20.7891 31.0589 20.7891 31.4053C20.7891 31.7517 20.926 32.0842 21.1709 32.3291C21.3535 32.5118 21.5865 32.6361 21.8398 32.6865C22.0932 32.7369 22.3561 32.7111 22.5947 32.6123C22.8334 32.5134 23.0381 32.3457 23.1816 32.1309C23.3251 31.9161 23.4013 31.6635 23.4014 31.4053C23.4014 31.1471 23.325 30.8944 23.1816 30.6797C23.0381 30.4649 22.8334 30.2971 22.5947 30.1982C22.356 30.0994 22.0932 30.0736 21.8398 30.124Z"
      fill="#1DB6BD"
      stroke="#18181B"
    />
    <path d="M16 13H22" stroke="black" />
    <path d="M16 16H32" stroke="black" />
    <path d="M16 19H28" stroke="black" />
    <path
      d="M8 0.5H40C44.1421 0.5 47.5 3.85786 47.5 8V40C47.5 44.1421 44.1421 47.5 40 47.5H8C3.85786 47.5 0.5 44.1421 0.5 40V8C0.500001 3.85786 3.85787 0.5 8 0.5Z"
      stroke="#d2d7dc"
    />
  </svg>
</template>

<script>
export default {
  name: 'BlogWithBorder',
}
</script>

<style lang="scss" scoped>
.a {
  fill: #fff;
  stroke: #d2d7dc;
}
.b {
  fill: #05b5bc;
}
.c,
.d,
.f {
  fill: none;
}
.c {
  stroke: #2d323c;
  stroke-width: 1.057px;
}
.c,
.d {
  stroke-miterlimit: 10;
}
.e,
.g {
  stroke: none;
}
.g {
  fill: #2d323c;
}
</style>
